import { ref } from 'vue';

// T-234: o clique direito no card pede o encerramento, mas quem sabe encerrar é a tela da
// conversa.
//
// O problema concreto: "Marcar como resolvida" no menu de contexto chamava o `toggleStatus`
// direto e CONTORNAVA a trava de tabulação, que mora no botão Resolver. Dava para encerrar sem
// tabular, exatamente o que a Tamara pediu que não acontecesse ("todos os encerramentos eu
// preciso tabular"). O T-237 tirou o item da mão do agente em 24/09; em 25/09 o Douglas decidiu
// que o administrador também passa pela mesma porta.
//
// POR QUE NÃO ABRIR A TELA DE TABULAÇÃO NO PRÓPRIO MENU: ela e o composable que a alimenta leem
// a conversa ABERTA (`getSelectedChat`), e o clique direito age num card que muitas vezes não é
// a conversa aberta. Reusar ali tabularia a conversa errada, que é pior do que não tabular.
//
// POR QUE NÃO UM TEMPORIZADOR depois de navegar: a tela da conversa monta de forma assíncrona, e
// um `setTimeout` chutado ora chega antes ora depois. Este pedido é um estado compartilhado: o
// menu deixa registrado, a tela consome quando estiver pronta. Sem corrida.
const pendente = ref(null);

export function useFandataResolverPendente() {
  // Chamado pelo menu de contexto, imediatamente antes de navegar para a conversa.
  const pedirEncerramento = conversationId => {
    pendente.value = conversationId;
  };

  // Chamado pela tela da conversa. Só consome o pedido da conversa CERTA, e só uma vez: se o
  // agente navegar para outro lugar no meio do caminho, o pedido morre em vez de encerrar um
  // atendimento que ele não escolheu.
  const consumirEncerramento = conversationId => {
    if (pendente.value == null || pendente.value !== conversationId) return false;

    pendente.value = null;
    return true;
  };

  return { pedirEncerramento, consumirEncerramento };
}
